import * as React from 'react';

interface ITrain {
    color?: string; // ex: #f03742
}
const Train: React.FC<ITrain> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="18"
            height="20"
            viewBox="0 0 18 20"
        >
            <defs>
                <path
                    id="gf240suhha"
                    d="M18.04 13.72l-2.48-9.296c-.076-.287-.336-.487-.635-.487h-3.099V2.625h2.627V1.312H7.886v1.313h2.627v1.313h-3.01c-.295 0-.552.195-.63.48l-2.575 9.24c-.072.265.026.547.248.709l6.285 4.54c.114.082.25.124.384.124.136 0 .27-.042.385-.124l6.192-4.485c.221-.16.32-.439.249-.701zm-8.84.061c-.37 0-.657-.298-.657-.656 0-.358.287-.656.656-.656.37 0 .657.298.657.656 0 .358-.288.656-.657.656zm3.94 0c-.37 0-.657-.298-.657-.656 0-.358.287-.656.656-.656.37 0 .657.298.657.656 0 .358-.288.656-.657.656zm-6.322 3.036l1.132.82L4.595 21h-1.97l4.193-4.183zm8.679 0L19.687 21h-1.97l-3.354-3.364 1.134-.819zm-2.18-10.255l.807 3.307-2.96 1.287-2.95-1.307.84-3.287h4.263z"
                />
            </defs>
            <g fill="none" fill-rule="evenodd">
                <g>
                    <g>
                        <g transform="translate(-187.000000, -1548.000000) translate(182.000000, 1544.000000) translate(3.000000, 3.000000)">
                            <use fill="#FFFFFF" fill-rule="nonzero" xlinkHref="#gf240suhha" />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
export default Train;
